
















import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
	name: 'modal',
	components: {

	},
	props: {
		size: {
			default: ''
		},
		showClose: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			style: style
		}
	},
	computed: {
		modalSizeClass(): string {
			switch (this.size) {
				case 'sm':
					return this.style.modalSm
				case 'xl':
					return this.style.modalXl
				default:
					return this.style.modalMid
			}
		}
	}
});
